// extracted by mini-css-extract-plugin
module.exports = {"cls1":"CinePlayer-Loading-module--cls1--ajdp7","cls2":"CinePlayer-Loading-module--cls2--1m-Ab CinePlayer-Loading-module--cls1--ajdp7"};